import * as THREE from 'three'

// Greyscale cel ramp for MeshToonMaterial.gradientMap. `bands` sets the number
// of tones; `smoothness` 0 = hard cel (NearestFilter — bands stay crisp), >0 =
// soft terminator (LinearFilter smears between steps). Cached per (bands,filter).
const _cache = new Map()

export function getToonRamp(bands = 3, smoothness = 0) {
  const n = Math.max(2, Math.min(8, Math.round(bands || 3)))
  const soft = (smoothness || 0) > 0
  const key = `${n}:${soft ? 'L' : 'N'}`
  const hit = _cache.get(key)
  if (hit) return hit

  const data = new Uint8Array(n)
  // Evenly spaced 0..255 across n steps (deep shadow → lit highlight).
  for (let i = 0; i < n; i++) data[i] = Math.round((i / (n - 1)) * 255)
  const tex = new THREE.DataTexture(data, n, 1, THREE.RedFormat)
  tex.minFilter = soft ? THREE.LinearFilter : THREE.NearestFilter
  tex.magFilter = soft ? THREE.LinearFilter : THREE.NearestFilter
  tex.generateMipmaps = false
  tex.needsUpdate = true
  _cache.set(key, tex)
  return tex
}
